/*
 * swagger 생성물에 없는 수동 query key 를 여기에 추가한다.
 * (generate-swagger 재생성 시에도 이 파일은 보존된다)
 */
export const CUSTOM_QUERY_KEY = {} as const;
